import { render, staticRenderFns } from "./UsersTabsIndex.vue?vue&type=template&id=1bf71745"
import script from "./UsersTabsIndex.vue?vue&type=script&lang=js"
export * from "./UsersTabsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports